import { generateInputFieldBase } from '../InputField/index.shell';
import { forwardRef } from 'react';
export const TextField = forwardRef((props, ref) => generateInputFieldBase('chameleon-text-field', props, ref));
